import { Message } from './types';
import { ModalImages } from '../modals/types';
import { store } from '../../app/store';
import { hideModal } from '../modals/modalsSlice';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';

const defaultMessage: Message = {
  title: 'Что-то пошло не так :(',
  message:
    'Попробуйте активировать подарок<br> позднее. Если ошибка повторится,<br> позвоните по бесплатному номеру<br> 0500 для решения проблемы ',
  imageClass: ModalImages.Wait,
  buttonFirst: {
    text: 'Закрыть',
    onClick: () => store.dispatch(hideModal()),
  },
};

const getMessageFromCode = (code: number): Message => {
  switch (code) {
    case 200:
      return {
        title: 'Успешно',
        message: 'Подарок активирован.<br> Мы отправим вам<br> подробности в SMS',
        imageClass: ModalImages.Gift,
        buttonFirst: {
          text: 'Закрыть',
          onClick: () => {
            store.dispatch(hideModal());
            trackEventBound(
              EventGTM.MakeActions,
              EventId.ClickButtonInSubscriptionGiftSuccessModal,
              EventCat.Gift,
              EventName.ClickElement,
              'Подарок активирован / Закрыть'
            );
          },
        },
      };
    case 411:
      return {
        title: 'У вас уже подключена подписка',
        message:
          'Для активации промокода дождитесь<br> окончания оплаченного периода<br> подписки и отключите её',
        note: 'Промокод можно активировать<br> по 31.12.2021 включительно',
        imageClass: ModalImages.Wait,
        buttonFirst: {
          text: 'Закрыть',
          onClick: () => store.dispatch(hideModal()),
        },
      };
    case 412:
      return {
        title: 'Ой!',
        message:
          'Подарок может получить только<br> абонент МегаФона.<br> Введите другой номер телефона',
        imageClass: ModalImages.Cry,
        buttonFirst: {
          text: 'Ввести другой номер',
          onClick: () => store.dispatch(hideModal()),
        },
      };
    case 415:
      return {
        title: 'Ой!',
        message:
          'Похоже на вашем номере действует<br> запрет на подключение услуг.<br> Позвоните по бесплатному номеру<br> 0500, чтобы снять ограничения',
        imageClass: ModalImages.Cry,
        buttonFirst: {
          text: 'Позвонить 0500',
          url: 'tel:0500',
        },
      };
    case 417:
      return {
        title: 'Что-то пошло не так :(',
        message:
          'Попробуйте активировать подарок<br> позднее. Если ошибка повторится,<br> позвоните по бесплатному номеру<br> 0500 для решения проблемы',
        imageClass: ModalImages.Cry,
        buttonFirst: {
          text: 'Закрыть',
          onClick: () => store.dispatch(hideModal()),
        },
      };
    case 501:
      return {
        title: 'Недостаточно средств',
        message: 'Услуга может быть активирована<br> только при положительном балансе',
        imageClass: ModalImages.Cry,
        buttonFirst: {
          text: 'Пополнить баланс',
          url: 'https://pay.megafon.ru',
        },
      };
    case 506:
      return {
        title: 'Услуга уже подключена',
        message: 'Начните пользоваться прямо сейчас!',
        imageClass: ModalImages.Wait,
      };
    case 500:
      return defaultMessage;
    default:
      return defaultMessage;
  }
};

export default getMessageFromCode;
